import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=2265d0ae"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=2265d0ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports